import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel, SectionLabel, StatusBadge } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const blank = { host: "", port: 465, security: "ssl", username: "", password: "", from_email: "", from_name: "" };
const F = [["host", "Server SMTP (es. smtps.aruba.it)"], ["port", "Porta"], ["username", "Utente"], ["password", "Password"], ["from_email", "Email mittente"], ["from_name", "Nome mittente"]];

export const MailSettingsPanel = () => {
  const { me } = useAuth();
  const [f, setF] = useState(null);
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);
  const guestAdmin = me?.tenant?.slug && me?.role?.key === "super_admin";
  useEffect(() => { if (guestAdmin) api.get("/admin/mail-settings").then((r) => { setSaved(!!r.data.settings); setF({ ...blank, ...(r.data.settings || {}), password: "" }); }).catch(() => {}); }, [guestAdmin]);
  if (!guestAdmin || !f) return null;
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/admin/mail-settings", { ...f, port: Number(f.port), password: f.password || null }); setSaved(true); setF({ ...f, password: "" }); toast.success(`Casella collegata: email di prova inviata a ${r.data.test_sent_to}`); }
    catch (x) { toast.error(errorMessage(x)); } finally { setBusy(false); }
  };
  return (
    <Panel className="p-5 lg:col-span-3" data-testid="mail-settings-panel">
      <div className="mb-2 flex items-center gap-2"><Mail className="h-4 w-4 text-slate-400" /><SectionLabel>Email di invio dell'azienda</SectionLabel>
        <StatusBadge tone={saved ? "green" : "amber"}>{saved ? "Collegata" : "Non collegata"}</StatusBadge></div>
      <p className="mb-4 text-xs text-slate-500">Da questa casella partono le email automatiche (offerte, firma, fatture, promemoria, conferme del modulo sito). Al salvataggio inviamo un'email di prova a te: si salva solo se l'invio riesce. La password resta cifrata e non viene più mostrata.</p>
      <div className="grid gap-3 md:grid-cols-3">
        {F.map(([k, l]) => <div key={k} className="space-y-1.5"><Label className="text-xs">{l}{k === "password" && saved ? " (vuoto = invariata)" : ""}</Label>
          <Input type={k === "password" ? "password" : k === "port" ? "number" : "text"} value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`mail-input-${k}`} /></div>)}
        <div className="space-y-1.5"><Label className="text-xs">Sicurezza</Label>
          <select value={f.security} onChange={(e) => setF({ ...f, security: e.target.value, port: e.target.value === "ssl" ? 465 : 587 })} className="h-9 w-full rounded-control border border-line px-2 text-sm" data-testid="mail-input-security">
            <option value="ssl">SSL (porta 465)</option><option value="starttls">STARTTLS (porta 587)</option></select></div>
      </div>
      <Button className="mt-4" onClick={save} disabled={busy} data-testid="mail-save">{busy ? "Prova di invio…" : "Salva e prova"}</Button>
    </Panel>
  );
};
